//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
// login-wrapper imports
import { styles } from "./NoRouteView.styles";
// other internals
import { clockwiseNotFoundHero, schedulingLink404 } from "@img/illustrations/";
import { H1, H2, P, A } from "@ui-marketing";
import { url } from "@constants/site.constant";
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";

//////////////////
// COMPONENT
//////////////////
const NoRouteViewComponent = (props: WithStyles<typeof styles>) => (
  <div className={props.classes.container} cw-id="page-not-found">
    <div className={props.classes.content}>
      <H1>Page not found!</H1>
      <H2>Sorry, but the page you were looking for could not be found.</H2>

      <P>
        You can return to our <A href={url}>home page</A>, or contact support{" "}
        <A href={articleUrls.feedback}>here</A>
      </P>
    </div>
    <img className={props.classes.img} src={clockwiseNotFoundHero} />
  </div>
);

export const SchedulingLinkNotFound = () => (
  <div
    className="cw-flex cw-items-center cw-flex-col-reverse md:cw-flex-row cw-px-5 md:cw-px-24 sm:cw-py-20 cw-py-8 md:cw-py-24 cw-min-h-[500px] cw-h-full md:cw-gap-10 cw-gap-7 cw-justify-between cw-max-w-6xl"
    cw-id="link-not-found"
  >
    <div className="cw-flex cw-flex-col cw-justify-center cw-shrink-0 cw-max-w-sm">
      <H1>This Clockwise Link is inactive</H1>
      <H2>Please contact the link sender to provide a new link</H2>

      <br />
      <P>
        If the link sender recently edited their Clockwise Links username, then the link above was
        marked inactive.
        <br />
        <br />
        If you experience additional issues with this link, you can reach us{" "}
        <A href={articleUrls.feedback}>here</A>.
      </P>
    </div>
    <img className="cw-max-w-sm lg:cw-max-w-md cw-w-full" src={schedulingLink404} />
  </div>
);

export const NoRouteView = withStyles(styles)(NoRouteViewComponent);
